export default class Language {
    getCurrentLanguage() {
        return window.document.getElementsByTagName('html')[0].getAttribute('lang');
    }
}
